import Cookies from "js-cookie"

export const tenantsInfo = {
  PK: {
    name: "zameen",
    slug: "PK",
    currency: "PKR",
    countryCode: "+92",
    timezone: "Asia/Karachi",
    default_city: "Lahore",
  },
  KSA: {
    name: "bayut",
    slug: "KSA",
    currency: "SAR",
    countryCode: "+966",
    timezone: "Asia/Riyadh",
    default_city: "Riyadh",
  },
}

const getTenant = () => {
  if (typeof window !== "undefined" && process.env.REACT_APP_NODE_ENV === "production") {
    const tenant = window && window.location.host.split(".")[0]
    return tenant
  } else {
    return Cookies.get("tenant") === tenantsInfo.KSA.slug ? tenantsInfo.KSA.name : tenantsInfo.PK.name
  }
}
export const CURRENT_TENANT = getTenant()

export const isTenantBayut = getTenant() === tenantsInfo.KSA.name ? true : false
export const isTenantZameen = getTenant() === tenantsInfo.PK.name ? true : false
